import React from "react";
import {
  CircleCheck,
  CircleDollarSign,
  Handshake,
  Landmark,
  Shield,
} from "lucide-react";

export type GuaranteeIconVariant =
  | "guarantor"
  | "deposit"
  | "insurance"
  | "bank"
  | "default";

const ICON_CLASS_NAME = "h-5 w-5";

export function resolveGuaranteeIconVariant(name: string): GuaranteeIconVariant {
  const normalizedName = name.toLowerCase();

  if (normalizedName.includes("fiador")) {
    return "guarantor";
  }

  if (
    normalizedName.includes("depósito") ||
    normalizedName.includes("deposito") ||
    normalizedName.includes("caução") ||
    normalizedName.includes("caucao")
  ) {
    return "deposit";
  }

  if (normalizedName.includes("seguro")) {
    return "insurance";
  }

  if (
    normalizedName.includes("fiança") ||
    normalizedName.includes("fianca") ||
    normalizedName.includes("bancária") ||
    normalizedName.includes("bancaria")
  ) {
    return "bank";
  }

  return "default";
}

export function getIconByGuaranteeName(name: string): React.ReactElement {
  switch (resolveGuaranteeIconVariant(name)) {
    case "guarantor":
      return React.createElement(Handshake, { className: ICON_CLASS_NAME });
    case "deposit":
      return React.createElement(CircleDollarSign, { className: ICON_CLASS_NAME });
    case "insurance":
      return React.createElement(Shield, { className: ICON_CLASS_NAME });
    case "bank":
      return React.createElement(Landmark, { className: ICON_CLASS_NAME });
    default:
      return React.createElement(CircleCheck, { className: ICON_CLASS_NAME });
  }
}
